<template>
  <div>
    <Header />
    <div class="app font-sans min-w-screen min-h-screen bg-black py-8 px-4">
      <div class="mail__wrapper max-w-md mx-auto">
        <div class="mail__content bg-gray-400 p-8 shadow-md rounded-lg">
          <div
            class="content__header h-128 flex flex-col items-center justify-center text-center tracking-wide leading-normal bg-black -mx-8 -mt-8"
          ></div>

          <div class="content__body py-8 border-b">
            <h3 class="text-center text-2xl sm:text-3xl pt-4 mb-8 ">
              Greetings {{ (userData || {}).displayName }}, <br />you're finally
              here! 🎉
            </h3>
            <p class="pt-4 leading-normal">
              Welcome!<br /><br />
              To get the most of this app, you'll have to make payments!
            </p>
            <div
              v-if="this.userData && !(this.userData.phoneNumber || '').length"
            >
              <div
                class="w-full md:flex justify-start items-center font-medium p-2 md:mb-3"
              >
                <span class="mr-3 w-auto">Please Enter your Phone number:</span>
              </div>
              <div
                class="w-full md:flex justify-start items-center font-medium p-2 md:mb-3"
              >
                <VuePhoneNumberInput
                  v-model="phoneNumber"
                  size="lg"
                  :dark="true"
                  color="black"
                  valid-color="#008000"
                  error-color="#ff0000"
                  dark-color="#c2c3c4"
                  :show-code-on-list="true"
                  :border-radius="30"
                  default-country-code="US"
                  mode="international"
                  :enabledCountryCode="true"
                  :validCharactersOnly="true"
                  @update="onUpdate"
                  class="phone-ctr focus:outline-none w-full md:w-3/4 text-gray-900 py-2 md:py-3 bg-opacity-75 px-5"
                />
              </div>
            </div>
            <button
              @click="navigate"
              class="text-white text-sm tracking-wide bg-custom rounded-full hover:shadow-lg w-full my-8 p-4 "
            >
              MAKE PAYMENTS
            </button>
            <p class="text-sm">
              Keep Rockin'!<br />
              Spyows
            </p>
          </div>

          <div class="content__footer mt-8 text-center text-grey-darker">
            <h3 class="text-base sm:text-lg mb-4">Thanks for choosing us.</h3>
            <p>www.spyonwallstreet.com/</p>
          </div>
        </div>

        <div class="mail__meta text-center text-sm text-grey-darker mt-8">
          <div class="meta__social flex justify-center my-4">
            <a
              href="#"
              class="flex items-center justify-center mr-4 bg-black text-white rounded-full w-8 h-8 no-underline"
              ><i class="bx bxl-facebook"></i
            ></a>
            <a
              href="#"
              class="flex items-center justify-center mr-4 bg-black text-white rounded-full w-8 h-8 no-underline"
              ><i class="bx bxl-instagram"></i
            ></a>
            <a
              href="#"
              class="flex items-center justify-center bg-black text-white rounded-full w-8 h-8 no-underline"
              ><i class="bx bxl-twitter"></i
            ></a>
          </div>

          <div class="meta__help">
            <p class="leading-loose">
              Questions or concerns?
              <a href="mailto:help@spyows.com" class="text-grey-darkest">
                help@spyows.com
              </a>

              <br />
              Want to quit getting updates?
              <a href="mailto:help@spyows.com" class="text-grey-darkest">
                Unsubscribe
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- Facebook Pixel Code -->
<script>
!(function(f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function() {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = "2.0";
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(
  window,
  document,
  "script",
  "https://connect.facebook.net/en_US/fbevents.js"
);
// eslint-disable-next-line no-undef
fbq("init", "261976718326827");
// eslint-disable-next-line no-undef
fbq("track", "PageView");
</script>
<noscript><img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=261976718326827&ev=PageView&noscript=1"
/></noscript>
<!-- End Facebook Pixel Code -->
<script>
import Header from "@/components/layout/Header.vue";
import firebase from "firebase";
import Auth from "@/providers/auth";

export default {
  name: "Welcome",
  components: {
    Header,
    VuePhoneNumberInput
  },
  data() {
    return {
      name: "John Doe",
      userData: null,
      phoneNumber: "",
      phoneNumberResults: {}
    };
  },
  mounted() {
    let user = firebase.auth().currentUser;
    firebase
      .database()
      .ref(`users/${user.uid}`)
      .on("value", snapshot => {
        this.userData = snapshot.val();
      });
  },
  methods: {
    onUpdate(payload) {
      this.phoneNumberResults = payload;
    },
    navigate() {
      if (
        !(this.userData.phoneNumber || "").length &&
        !this.phoneNumberResults.isValid
      ) {
        this.$vToastify.error("Please enter PhoneNumber");
      } else if (
        !(this.userData.phoneNumber || "").length &&
        this.phoneNumberResults.isValid
      ) {
        Auth.updateUserData(this.userData.uid, {
          phoneNumber: this.phoneNumberResults["formattedNumber"]
        })
          .then(() => {
            this.$router.push({ name: "Payment" });
          })
          .catch(err => {
            this.$vToastify.error(
              "Failed to update PhoneNumber please try again later"
            );
          });
      } else {
        this.$router.push({ name: "Payment" });
      }
    }
  }
};
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
</script>

<style lang="css" scoped>
.content__header {
  background: #070d12
    url(https://images.unsplash.com/photo-1512499582704-623afeaf82c9?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=9fe691e9e5263a1fd49c1c5f88812e03&auto=format&fit=crop&w=2766&q=80)
    no-repeat;
  background-position: center 1px;
  background-size: cover;
}
.phone-ctr {
  padding: 0 !important;
}
div#MazPhoneNumberInput {
  width: fit-content;
}
</style>
